module.exports = __webpack_public_path__ + "static/media/whatsapp_nofill.ebb20a59.svg";